import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var BlockDataContext = /*#__PURE__*/createContext({});
export var useBlockData = function useBlockData() {
  return useContext(BlockDataContext);
};
export var BlockDataProvider = function BlockDataProvider(_ref) {
  var children = _ref.children,
      id = _ref.id,
      typename = _ref.typename;
  return /*#__PURE__*/_jsx(BlockDataContext.Provider, {
    value: {
      id: id,
      typename: typename
    },
    "data-element": "unknown",
    "data-component": "BlockDataProvider",
    "data-source-file": "block-data-provider.tsx",
    children: children
  });
};